<script lang="ts" setup>
import type { TripPlannerQueryParams } from '../new-desktop/core/models/navigation';
import { useQueryParamsStore } from '../new-desktop/core/stores/queryParamsStore';
import { useRouterStore } from '../new-desktop/core/stores/routerStore';
import { useRecipeStore } from '../new-desktop/core/stores/recipe/recipeStore';

import TripPlanner from './TripPlanner.vue';

const props = defineProps<TripPlannerQueryParams>();

//Refactor what: Extract state setup function calls
//Refactor why: These have to be updated manually in every test file if any changes are made.
const recipeStore = useRecipeStore();
recipeStore.initializeProps({
  pax: props.initialPax,
  recipe: props.initialIngredients,
  preferredDay: props.initialSelectedDate,
  preferredMonth: props.initialSelectedMonth,
  itinerarySuggestionSortType: props.initialSuggestionSortType,
  returnTransport: props.returnTransport,
  metadata: props.metaData,
  searchForPackageRates: props.searchForPackageRates,
});

const queryParamStore = useQueryParamsStore();
queryParamStore.setQueryParams(props);

const routerStore = useRouterStore();
routerStore.setLandingRoute();
</script>

<template>
  <TripPlanner v-bind="props" />
</template>
